import { render, staticRenderFns } from "./ParticipantsCourseoutcomesScore.vue?vue&type=template&id=5af6b2db"
import script from "./ParticipantsCourseoutcomesScore.vue?vue&type=script&lang=js"
export * from "./ParticipantsCourseoutcomesScore.vue?vue&type=script&lang=js"
import style0 from "./ParticipantsCourseoutcomesScore.vue?vue&type=style&index=0&id=5af6b2db&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports